import { Formik, FormikHelpers } from 'formik'
import { Button, InputField, Modal } from '../../../../components'
import { useAppDispatch } from '../../../../redux/hook'
import { editBrand } from '../../slice/brandSlice'
import { addBrandSchema } from '../../schema'
import { useTranslation } from 'react-i18next'
interface AddModalProps {
    show: boolean
    onClose: (value: boolean) => void
    data: {
        name: string
        description: string
        id: string
    }
}
interface addBrandFormValues {
    name: string
    description: string
}
const EditBrand = ({ show, onClose, data }: AddModalProps) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title={t('brand.brandModals.editModalTitle')}
            body={
                <Formik
                    initialValues={{
                        name: data.name,
                        description: data.description,
                    }}
                    validationSchema={addBrandSchema}
                    onSubmit={(
                        values,
                        actions: FormikHelpers<addBrandFormValues>
                    ) => {
                        dispatch(editBrand({ ...values, id: data.id }))
                        actions.setSubmitting(false)
                        onClose(false)
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <InputField
                                type="text"
                                name="name"
                                lable={t('lable.brandName')}
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.name}
                                touched={touched.name}
                            />
                            <InputField
                                type="text"
                                name="description"
                                lable={t('lable.description')}
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.description}
                                touched={touched.description}
                            />
                            <Button disabled={isSubmitting} type="submit">
                                {t('button.edit')}
                            </Button>
                        </form>
                    )}
                </Formik>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default EditBrand
